module.exports = __webpack_public_path__ + "json/buildings-5.json?f8416ebe47a64f7bc41f6713b752c523";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-5.json
// module id = 1724
// module chunks = 3